import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=2c27c109&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c27c109')) {
      api.createRecord('2c27c109', component.options)
    } else {
      api.reload('2c27c109', component.options)
    }
    module.hot.accept("./_id.vue?vue&type=template&id=2c27c109&", function () {
      api.rerender('2c27c109', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apply/approval/_id.vue"
export default component.exports